const sketchyColors = [
    { name: "Black", hc: "#000000", order: 1 },
    { name: "Red", hc: "#FF0000", order: 2 },
    { name: "Orange", hc: "#FF6600", order: 3 },
    { name: "Yellow", hc: "#FFFF00", order: 4 },
    { name: "Green", hc: "#00FF00", order: 5 },
    { name: "Blue", hc: "#0000FF", order: 6 },
    { name: "Purple", hc: "#6600FF", order: 7 },
    { name: "White", hc: "#FFFFFF", order: 8 }
]

sketchyColors.sort((a, b) => a.order - b.order)

export default sketchyColors
